// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"InsuranceContractTypesList_tabHeader__3Cj65"};